import classnames from 'classnames/bind'
import React from 'react'
import { useTranslate } from 'react-polyglot'

import {
  ALL_NAME,
  BlogNavigationProps,
  getAllChecked,
} from '~/components/Navigation/BlogNavigation'
import Button, {
  ButtonType,
} from '~/components/Navigation/BlogNavigation/Button'

import { FILTER } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface PanelListProps {
  className?: string
  title?: string
  isOpen?: boolean
  onClose?(): void
  items?: BlogNavigationProps['categories']
}

function PanelList({
  className,
  isOpen,
  title,
  onClose,
  items,
}: PanelListProps) {
  const t = useTranslate()
  const allChecked = getAllChecked(items)

  const onClickClose = () => {
    onClose?.()
  }

  return isOpen ? (
    <div className={cx(className, css.PanelList)}>
      <div className={cx(css.container)}>
        <div className={css.background} onClick={onClickClose} />
        <div className={cx(css.content)}>
          <div className={cx(css.subContent)}>
            <Button
              className={cx(css.button)}
              name={ALL_NAME}
              type={ButtonType.Dot}
              checked={allChecked}
            >
              {`${t(FILTER.ALL)} ${title ?? ''}`}
            </Button>
            {items?.length > 0 &&
              items?.map(({ key, value, checked }, index) => (
                <Button
                  key={`${key}_${index}`}
                  name={key}
                  className={cx(css.button)}
                  type={ButtonType.Dot}
                  checked={checked}
                >
                  {value}
                </Button>
              ))}
          </div>
        </div>
      </div>
    </div>
  ) : null
}

export default PanelList
